var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.tour_to_actually_show,{tag:"component",on:{"stopShowingThisTour":_vm.stopShowingThisTour}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }